import '.a{display:grid;}.ssr-plugin'
import '.h9{grid-template-columns:repeat(3, minmax(250px, 1fr));}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { BlogCard } from '../../card/BlogCard'
import { geographyArticleLink, type GeographyPage } from '@app/util/links'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { styled } from 'inlines'
import { StoredImage } from '@app/types/StoredImage'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type NewsContentSectionType = {
  type: 'news'
  title: string
  pageSlug?: string
  geographyPage?: GeographyPage
  titleLevel?: 'H1' | 'H2' | 'H3' | 'H4'
  seeMoreLabel?: string
  seeMoreLink?: string
  items: {
    id: number
    slug: string
    title: string
    intro?: string
    images?: StoredImage[]
  }[]
}

const NewsCardItem = ({
  pageSlug = '',
  geographyPage,
  item,
  index,
  meta,
}: {
  pageSlug?: string
  geographyPage?: GeographyPage
  item: NewsContentSectionType['items'][number]
  index: number
  meta: string
}) => {
  const appearStyle = useAppearStyle(index + 1)

  return (
    <BlogCard
      title={item.title}
      meta={meta}
      image={item.images?.[0]}
      intro={item.intro}
      to={geographyArticleLink(geographyPage, pageSlug, 'news', item.slug)}
      style={appearStyle}
    />
  )
}

export const NewsContentSection = ({
  title,
  titleLevel = 'H2',
  seeMoreLabel,
  seeMoreLink,
  pageSlug,
  geographyPage,
  items,
}: NewsContentSectionType) => {
  const translations = useTranslations().app
  const t = translations.blogPage

  if (items.length === 0) return null

  return (
    <Column gap="0.5rem" alignItems="stretch">
      <AppearItem staggerIndex={0}>
        {seeMoreLink ? (
          <SectionHeader
            title={title}
            titleLevel={titleLevel}
            seeMore={seeMoreLabel ?? translations.common.seeMore}
            toRoute={seeMoreLink}
          />
        ) : (
          <Title.Hx title={titleLevel}>{title}</Title.Hx>
        )}
      </AppearItem>
      <styled.div className="a h9 g"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(2, minmax(250px, 1fr))',
          },
          '@media (max-width: 800px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {items.map((item, index) => (
          <NewsCardItem
            key={item.id}
            item={item}
            index={index}
            pageSlug={pageSlug}
            geographyPage={geographyPage}
            meta={t.tabs['news']}
          />
        ))}
      </styled.div>
    </Column>
  )
}
